module.exports = __webpack_public_path__ + "img/VR&P-ST.png.361bc065.webp";